import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ModalOverlayContent } from '../container-overlay/styled';
import LoadingView from '../view-loading';
const Image = /*#__PURE__*/_styled('img', process.env.NODE_ENV === "production" ? {
  target: "e10mygzg0"
} : {
  target: "e10mygzg0",
  label: "Image"
})(process.env.NODE_ENV === "production" ? {
  name: "vnkovg",
  styles: "max-height:100%;max-width:100%"
} : {
  name: "vnkovg",
  styles: "max-height:100%;max-width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3RoaWJhdXQubGVyb3kvQnVyZWF1L1BST0pFVFMvYWxnYXIvcG1kYy1teS1zcGFjZS9hcHAvc3JjL2NvbXBvbmVudHMvb3ZlcmxheS1pbWFnZS9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRMkIiLCJmaWxlIjoiL2hvbWUvdGhpYmF1dC5sZXJveS9CdXJlYXUvUFJPSkVUUy9hbGdhci9wbWRjLW15LXNwYWNlL2FwcC9zcmMvY29tcG9uZW50cy9vdmVybGF5LWltYWdlL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCB9IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnXG5cbmltcG9ydCB7IE1vZGFsT3ZlcmxheUNvbnRlbnQgfSBmcm9tICcuLi9jb250YWluZXItb3ZlcmxheS9zdHlsZWQnXG5cbmltcG9ydCBMb2FkaW5nVmlldyBmcm9tICcuLi92aWV3LWxvYWRpbmcnXG5cbmNvbnN0IEltYWdlID0gc3R5bGVkKCdpbWcnKWBcbiAgbWF4LWhlaWdodDogMTAwJTtcbiAgbWF4LXdpZHRoOiAxMDAlO1xuYFxuXG5jbGFzcyBJbWFnZU92ZXJsYXkgZXh0ZW5kcyBDb21wb25lbnQge1xuICBjb25zdHJ1Y3RvciAocHJvcHMpIHtcbiAgICBzdXBlcihwcm9wcylcbiAgICB0aGlzLnN0YXRlID0ge1xuICAgICAgbG9hZGluZzogdHJ1ZVxuICAgIH1cbiAgICB0aGlzLmhhbmRsZUxvYWRFbmQgPSB0aGlzLmhhbmRsZUxvYWRFbmQuYmluZCh0aGlzKVxuICB9XG5cbiAgaGFuZGxlTG9hZEVuZCAoKSB7XG4gICAgdGhpcy5zZXRTdGF0ZSh7IGxvYWRpbmc6IGZhbHNlIH0pXG4gIH1cblxuICByZW5kZXIgKCkge1xuICAgIHJldHVybiAoXG4gICAgICA8TW9kYWxPdmVybGF5Q29udGVudCBub1Njcm9sbD17dGhpcy5zdGF0ZS5sb2FkaW5nfT5cbiAgICAgICAge3RoaXMuc3RhdGUubG9hZGluZyAmJiA8TG9hZGluZ1ZpZXcgLz59XG4gICAgICAgIDxJbWFnZSBvbkxvYWQ9e3RoaXMuaGFuZGxlTG9hZEVuZH0gc3JjPXt0aGlzLnByb3BzLnNyY30gLz5cbiAgICAgIDwvTW9kYWxPdmVybGF5Q29udGVudD5cbiAgICApXG4gIH1cbn1cblxuSW1hZ2VPdmVybGF5LnByb3BUeXBlcyA9IHtcbiAgc3JjOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWRcbn1cblxuZXhwb3J0IGRlZmF1bHQgSW1hZ2VPdmVybGF5XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
class ImageOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
    this.handleLoadEnd = this.handleLoadEnd.bind(this);
  }
  handleLoadEnd() {
    this.setState({
      loading: false
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(ModalOverlayContent, {
      noScroll: this.state.loading
    }, this.state.loading && /*#__PURE__*/React.createElement(LoadingView, null), /*#__PURE__*/React.createElement(Image, {
      onLoad: this.handleLoadEnd,
      src: this.props.src
    }));
  }
}
ImageOverlay.propTypes = {
  src: PropTypes.string.isRequired
};
export default ImageOverlay;